import { withTargetValue } from '@ipfabric/ui-components/utils/events/withTargetValue';
import { TextInput } from 'components/TextInput/TextInput';
import type { FC } from 'react';

interface Props {
  hasError: boolean;
  onValueChange: (value: string) => void;
  onBlur: () => void;
  value: string;
  number?: boolean;
  stepper?: boolean;
}

export const TextFilterRule: FC<Props> = (props) => (
  <TextInput
    hasError={props.hasError}
    value={props.value}
    onChange={withTargetValue(props.onValueChange)}
    onBlur={props.onBlur}
    type={props.number ? 'number' : 'text'}
    size='small'
    stepper={props.stepper}
  />
);
